import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UtilString from '../../utils/UtilString';
import './MyLink.scss';

const MyLink = ({
  bold,
  path,
  state,
  style,
  search,
  onClick,
  children,
  underline,
  _blank = false,
  color = UtilString.EMPTY_STRING,
  className = UtilString.EMPTY_STRING,
}) => {
  const lang = useSelector((state) => {
    return state.lang;
  });

  const pathUrl = `/${lang}${path}`;

  const to = {
    pathname: `${pathUrl}`,
    search: search,
    state: state,
  };

  return (
    <Link
      style={style}
      onClick={onClick}
      className={`my_link ${color} ${className} ${
        bold ? 'text_bold_600' : ''
      } ${underline ? 'text_underline' : ''}`}
      to={to}
      target={_blank ? '_blank' : ''}
      state={state}
    >
      {children}
    </Link>
  );
};

export default MyLink;
